import React, { useState } from 'react';
import { toast } from 'react-toastify';

const CapturaModal = ({
  show,
  onClose,
  modalTitle,
  modalContent,
  modalError,
  selectedCuota,
  handleConfirmarPagoPrepagado,
  handleRechazarPagoPrepagado,
  selectedCliente,
  selectedPrestamo,
}) => {
  const [motivo, setMotivo] = useState('Comprobante equivocado'); // Default reason
  const [customMotivo, setCustomMotivo] = useState('');
  const [useCustomMotivo, setUseCustomMotivo] = useState(false);

  if (!show) return null;

  const genericMotivos = [
    'Comprobante equivocado',
    'Monto incorrecto',
    'Fecha de pago inválida',
    'Comprobante ilegible',
    'Otro',
  ];

  const handleRechazar = async () => {
    // Validate required fields
    if (!selectedCuota) {
      toast.error('No se ha seleccionado una cuota');
      return;
    }
    if (!selectedCliente) {
      toast.error('No se ha seleccionado un cliente');
      return;
    }
    if (!selectedPrestamo) {
      toast.error('No se ha seleccionado un préstamo');
      return;
    }

    // Determine final motivo
    let finalMotivo = motivo.trim();
    if (useCustomMotivo) {
      finalMotivo = customMotivo.trim();
      if (!finalMotivo) {
        toast.error('El motivo personalizado no puede estar vacío');
        return;
      }
    } else {
      // Ensure generic motivo is valid
      if (!genericMotivos.includes(finalMotivo)) {
        toast.error('Por favor, seleccione un motivo válido');
        return;
      }
    }

    try {
      await handleRechazarPagoPrepagado({
        idCliente: selectedCliente.idUsuario,
        idPrestamo: selectedPrestamo.idPrestamo,
        idCuota: selectedCuota.idCuota,
        motivo: finalMotivo,
      });
      onClose();
    } catch (error) {
      toast.error(error.message || 'Error al rechazar el pago');
    }
  };

  return (
    <div className="modal-overlay">
      <div className="modal-panel modal-panel-lg relative p-6">
        <button
          onClick={onClose}
          className="absolute right-4 top-4 text-slate-500 transition hover:text-slate-700"
          title="Cerrar"
          aria-label="Cerrar modal"
        >
          <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12" />
          </svg>
        </button>
        <h3 className="modal-title mb-4 text-blue-700">{modalTitle}</h3>
        {modalError ? (
          <div className="rounded-xl border border-red-200 bg-red-50 p-4">
            <p className="text-red-800 font-medium">{modalError}</p>
          </div>
        ) : (
          <div className="space-y-4">
            {modalContent.capturaUrl ? (
              <div>
                <h4 className="modal-label">Captura de Pago</h4>
                <img
                  src={modalContent.capturaUrl}
                  alt="Captura de Pago"
                  className="max-h-[70vh] w-full rounded-xl border border-slate-200 object-contain"
                />
              </div>
            ) : (
              <div className="rounded-xl border border-yellow-200 bg-yellow-50 p-4">
                <p className="text-yellow-800 font-medium">No hay captura de pago disponible.</p>
              </div>
            )}
          </div>
        )}
        {selectedCuota && selectedCuota.estado === 'prepagado' && !modalError && (
          <div className="mt-4">
            <div className="mb-4">
              <label htmlFor="motivo" className="modal-label">
                Motivo de Rechazo
              </label>
              <select
                id="motivo"
                value={motivo}
                onChange={(e) => setMotivo(e.target.value)}
                disabled={useCustomMotivo}
                className="modal-select"
              >
                {genericMotivos.map((m) => (
                  <option key={m} value={m}>{m}</option>
                ))}
              </select>
            </div>
            <div className="mb-4 flex items-center">
              <input
                type="checkbox"
                id="customMotivo"
                checked={useCustomMotivo}
                onChange={(e) => setUseCustomMotivo(e.target.checked)}
                className="h-4 w-4 rounded border-gray-300 text-blue-600 focus:ring-blue-500"
              />
              <label htmlFor="customMotivo" className="ml-2 text-sm text-gray-700">
                Especificar motivo personalizado
              </label>
            </div>
            {useCustomMotivo && (
              <div className="mb-4">
                <label htmlFor="customMotivoText" className="modal-label">
                  Motivo Personalizado
                </label>
                <textarea
                  id="customMotivoText"
                  value={customMotivo}
                  onChange={(e) => setCustomMotivo(e.target.value)}
                  className="modal-textarea"
                  rows="4"
                  placeholder="Escriba el motivo del rechazo..."
                />
              </div>
            )}
            <div className="modal-actions">
              <button
                onClick={handleConfirmarPagoPrepagado}
                className="btn-modal-success"
                aria-label="Confirmar pago prepagado"
              >
                Confirmar Pago
              </button>
              <button
                onClick={handleRechazar}
                className="btn-modal-danger"
                aria-label="Rechazar pago prepagado"
              >
                Rechazar Pago
              </button>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default CapturaModal;
